import { render, staticRenderFns } from "./ActivityAdd.vue?vue&type=template&id=07835074&scoped=true"
import script from "./ActivityAdd.vue?vue&type=script&lang=js"
export * from "./ActivityAdd.vue?vue&type=script&lang=js"
import style0 from "./ActivityAdd.vue?vue&type=style&index=0&id=07835074&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07835074",
  null
  
)

export default component.exports